// Enzica: Warn ONLY for default XS, allow intentional XS selection
(function () {
  const MSG =
    "⚠️ ATTENZIONE: Hai selezionato la taglia XS (35-37).\n\n" +
    "Se questa è la tua taglia corretta, clicca di nuovo per confermare.\n\n" +
    "Altrimenti seleziona la taglia giusta:\n" +
    "• Numero 38-40 → S\n" +
    "• Numero 39-41 → M\n" +
    "• Numero 42-44 → L\n" +
    "• Numero 45-48 → XL";

  const XS_WARN_KEY = "xs_size_warned";
  let userHasInteractedWithSizeSelector = false; // Track ANY size interaction

  // Detect if user clicks/changes ANY size option
  function trackSizeInteraction() {
    // Find all size-related elements
    const sizeSelectors = document.querySelectorAll(
      'select[name*="Size"], select[name*="size"], select[name*="Taglia"], select[name*="taglia"], ' +
      'button[data-variant-option], [role="radiogroup"] button, ' +
      '.size-selector button, .variant-selector button, ' +
      '[data-option-selector] button, .product-form__input button'
    );

    sizeSelectors.forEach(selector => {
      if (selector.__interaction_tracked) return;
      selector.__interaction_tracked = true;
      
      // Track clicks
      selector.addEventListener('click', () => {
        userHasInteractedWithSizeSelector = true;
        try {
          sessionStorage.removeItem(XS_WARN_KEY);
        } catch (_) {}
      });

      // Track changes (for dropdowns)
      selector.addEventListener('change', () => {
        userHasInteractedWithSizeSelector = true;
        try {
          sessionStorage.removeItem(XS_WARN_KEY);
        } catch (_) {}
      });
    });

    // Also track dropdown parent containers
    const dropdowns = document.querySelectorAll('select');
    dropdowns.forEach(select => {
      if (select.__interaction_tracked) return;
      select.__interaction_tracked = true;
      
      select.addEventListener('focus', () => {
        userHasInteractedWithSizeSelector = true;
      });
      
      select.addEventListener('mousedown', () => {
        userHasInteractedWithSizeSelector = true;
      });
    });
  }

  // Check if current selection is XS (35-37)
  function isCurrentlyXS() {
    const root = document.querySelector("#MainProduct-template--20028950413509__main") 
      || document.querySelector("main") 
      || document.body;

    // Check dropdown select elements
    const selectElements = Array.from(root.querySelectorAll('select option:checked'));
    for (const opt of selectElements) {
      const text = (opt.textContent || opt.value || "").trim();
      if (/XS.*35.*37|35.*37.*XS/i.test(text)) {
        return true;
      }
    }

    // Check active/selected buttons
    const selectedButtons = Array.from(root.querySelectorAll(
      'button[aria-checked="true"], button.selected, button.active, ' +
      'button[data-selected="true"], .size-selector button.active, ' +
      '[role="radio"][aria-checked="true"]'
    ));

    for (const btn of selectedButtons) {
      const text = (btn.textContent || "").trim();
      if (/XS.*35.*37|35.*37/i.test(text)) {
        return true;
      }
    }

    return false;
  }

  // Check if this is the first warning attempt
  function isFirstWarning() {
    try {
      return sessionStorage.getItem(XS_WARN_KEY) !== "warned";
    } catch (_) {
      return true;
    }
  }

  // Main logic: Should we show the warning?
  function shouldWarn() {
    // Only on product pages
    if (!location.pathname.includes("/products/")) return false;
    
    // If user has interacted with size selector, NEVER warn (even if XS)
    if (userHasInteractedWithSizeSelector) return false;
    
    // Only warn if CURRENTLY on XS AND user hasn't interacted AND first warning
    if (isCurrentlyXS() && isFirstWarning()) {
      return true;
    }

    return false;
  }

  // Find all checkout-related buttons (including COD button)
  function getCheckoutButtons() {
    // Get all buttons on the page
    const allButtons = Array.from(document.querySelectorAll('button, [role="button"], a.button'));
    
    return allButtons.filter(btn => {
      const text = (btn.textContent || '').toLowerCase().trim();
      const classes = (btn.className || '').toLowerCase();
      const id = (btn.id || '').toLowerCase();
      
      // Match various button types
      return (
        // Add to cart buttons
        text.includes('aggiungi') || text.includes('carrello') || 
        text.includes('add') || text.includes('cart') ||
        // COD buttons - improved detection for "Paga alla Consegna"
        text.includes('paga alla consegna') ||
        (text.includes('paga') && text.includes('consegna')) ||
        text.includes('cod') || text.includes('contrassegno') ||
        // Class/ID based detection
        classes.includes('cod') || classes.includes('consegna') ||
        id.includes('cod') || id.includes('consegna') ||
        // Shopify payment buttons
        btn.name === 'add' || classes.includes('shopify-payment-button')
      );
    });
  }

  // Bind click handlers to all checkout buttons
  function bindCheckoutButtons() {
    getCheckoutButtons().forEach(btn => {
      if (btn.__enzica_bound) return;
      btn.__enzica_bound = true;
      
      // Create a wrapper function that blocks all subsequent events
      const blockHandler = (e) => {
        if (shouldWarn()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          // Mark as warned
          try {
            sessionStorage.setItem(XS_WARN_KEY, "warned");
          } catch (_) {}
          
          // Show alert
          alert(MSG);
          
          // Block any follow-up events (especially important for mobile)
          setTimeout(() => {
            // Clear any pending navigation
            if (window.stop) window.stop();
          }, 10);
          
          return false;
        }
      };
      
      // Use multiple event listeners with capture phase for maximum coverage
      ['click', 'mousedown', 'touchstart', 'touchend', 'pointerdown'].forEach(eventType => {
        btn.addEventListener(eventType, blockHandler, true);
      });
      
      // Also add regular phase listeners as backup
      ['click', 'touchstart'].forEach(eventType => {
        btn.addEventListener(eventType, blockHandler, false);
      });
    });
  }

  // Prevent navigation to checkout after warning
  function preventCheckoutNavigation() {
    let navigationBlocked = false;
    let blockTimeout = null;
    
    // Store original alert function
    const originalAlert = window.alert;
    
    // Override alert to set navigation block flag
    window.alert = function(message) {
      if (message && message.includes('ATTENZIONE')) {
        navigationBlocked = true;
        
        // Clear any existing timeout
        if (blockTimeout) clearTimeout(blockTimeout);
        
        // Block navigation for 2 seconds after alert
        blockTimeout = setTimeout(() => {
          navigationBlocked = false;
        }, 2000);
      }
      return originalAlert.call(window, message);
    };
    
    // Intercept beforeunload to prevent navigation
    window.addEventListener('beforeunload', (e) => {
      if (navigationBlocked) {
        e.preventDefault();
        e.returnValue = '';
        
        // Stop any navigation attempts
        if (window.stop) window.stop();
        
        // Reset flag after a delay
        setTimeout(() => {
          navigationBlocked = false;
        }, 500);
        
        return '';
      }
    }, true);
    
    // Also intercept any click events that try to navigate during block period
    document.addEventListener('click', (e) => {
      if (navigationBlocked) {
        const target = e.target.closest('a, button');
        if (target) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
      }
    }, true);
  }

  // Also intercept the Releasit COD Form specifically
  function interceptCODForm() {
    // Listen for any modal/popup opening
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            // Check if this is the COD modal
            const text = node.textContent || '';
            if (text.includes('PAGAMENTO ALLA CONSEGNA') || 
                text.includes('COD') || 
                text.includes('Inserisci il tuo indirizzo')) {
              
              // If we should warn, close the modal immediately
              if (shouldWarn()) {
                // Try to close the modal
                const closeBtn = node.querySelector('[class*="close"], [aria-label*="close"], button[type="button"]');
                if (closeBtn) {
                  closeBtn.click();
                }
                // Or remove the modal directly
                if (node.remove) {
                  node.remove();
                }
                
                // Show warning
                try {
                  sessionStorage.setItem(XS_WARN_KEY, "warned");
                } catch (_) {}
                alert(MSG);
              }
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Initialize everything
  function init() {
    preventCheckoutNavigation();
    trackSizeInteraction();
    bindCheckoutButtons();
    interceptCODForm();
    
    // Re-scan periodically for dynamic content
    let tries = 0;
    const interval = setInterval(() => {
      trackSizeInteraction();
      bindCheckoutButtons();
      tries++;
      if (tries > 50) clearInterval(interval);
    }, 400);

    // Watch for DOM changes (Rapi/Shopify re-renders)
    const observer = new MutationObserver(() => {
      trackSizeInteraction();
      bindCheckoutButtons();
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Start when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();